import { setupAccordion } from "./components/accordion.js";
import { rankCarousel } from "./components/carousel.js";
import { handleReadMore } from "./components/readMore.js";
import { renderFixedButton } from "./components/fixedButton.js";

document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
        setupAccordion();
    }
    rankCarousel();
    handleReadMore();
    renderFixedButton();

    document.querySelectorAll('.c-block-headline .l-link li.smVer a, .jsPrintSmVer').forEach(function(el) {
        el.addEventListener('click', function() {
            document.body.classList.add('simpleVer');
            document.querySelectorAll('img[loading="lazy"]').forEach(img => {
                img.loading = 'eager'
            });
            setTimeout(() => {
                window.print();
            }, 100);
            setTimeout(function(){
                document.body.classList.remove('simpleVer');
            }, 200);
        });
    });
    document.querySelectorAll('.c-block-headline .l-link li:not(.smVer) a, .jsPrint').forEach(function(el) {
        el.addEventListener('click', function() {
            document.body.classList.remove('simpleVer');
            document.querySelectorAll('img[loading="lazy"]').forEach(img => {
                img.loading = 'eager'
            });
            setTimeout(() => {
                window.print();
            }, 100);
        });
    });
});
